import React, { Component } from 'react';
import styled from 'styled-components';
import { dark, primary } from 'react-components/dist/values/colors/colors';

const Wrapper = styled.div`
  background-color: ${primary}
    width: calc(100% - 20px);
    margin-left: ${props => (props.right ? 0 : -200)}px;
    margin-right: ${props => (props.right ? -200 : 0)}px;
    padding-right: ${props => (props.right ? 200 : 0)}px;
    left: ${props => (!props.right ? 200 : 0)}px;
    right: ${props => (props.right ? 200 : 0)}px;
    border-top-right-radius: ${props => (props.right ? 0 : 24)}px;
    border-bottom-right-radius: ${props => (props.right ? 0 : 24)}px;
    border-top-left-radius: ${props => (props.right ? 24 : 0)}px;
    border-bottom-left-radius: ${props => (props.right ? 24 : 0)}px;
    position:relative;
`;

const TextInner = styled.div`
  padding: 24px;
  box-sizing: border-box;
  line-height: 1.6em;
  margin: 0 auto;
  max-width: 800px;
`;
const DropShadow = styled.div`
    position:absolute;
    background-color: ${dark}
    height: 100%;
    width: 100%;
    top: 20px;
    z-index: -1;
    border-radius:24px;
    margin-left: ${props => (props.right ? -20 : 20)}px;
`;

class FlyingContainer extends Component {
  render() {
    return (
      <Wrapper
ref={this.props.containerRef}
right={this.props.right}>
        <TextInner right={this.props.right}>{this.props.children}</TextInner>
        <DropShadow right={this.props.right} />
      </Wrapper>
    );
  }
}

export default FlyingContainer;
